import ToolTip from './components/ToolTip';
export default ToolTip;



/** WEBPACK FOOTER **
 ** ./js/index.js
 **/